import React from 'react';
import Card from '../../../../Presentation/components/ui/Card';
import {StoreStatistics} from '../../models/store.model';
import {StoresStatisticsCards} from './StoresStatisticsCards';
import {StoresStatisticsSummary} from './StoresStatisticsSummary';
import {StoresStatisticsDetails} from './StoresStatisticsDetails';

interface StoresStatisticsTabProps {
  statistics: StoreStatistics | null;
  statisticsLoading: boolean;
  statisticsError: string | null;
}

export const StoresStatisticsTab: React.FC<StoresStatisticsTabProps> = ({
  statistics,
  statisticsLoading,
  statisticsError
}) => {
  if (statisticsLoading) {
    return (
      <Card className="p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600 mx-auto mb-4"></div>
          <p className="text-gray-600">جاري تحميل الإحصائيات...</p>
        </div>
      </Card>
    );
  }

  if (statisticsError) {
    return (
      <Card className="p-6 bg-red-50 border border-red-200">
        <div className="text-center">
          <p className="text-red-600 font-semibold">حدث خطأ في تحميل الإحصائيات</p>
          <p className="text-sm text-red-500 mt-1">{statisticsError}</p>
          <p className="text-xs text-red-400 mt-2">
            يرجى التواصل مع فريق الباك إند لحل مشكلة قاعدة البيانات
          </p>
        </div>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {/* الإحصائيات الأساسية */}
      <StoresStatisticsCards statistics={statistics} />

      {/* ملخص سريع */}
      <StoresStatisticsSummary statistics={statistics} />

      {/* تفاصيل إضافية */}
      <StoresStatisticsDetails statistics={statistics} />

      {/* آخر تحديث */}
      {statistics?.lastUpdated && (
        <Card className="p-6">
          <div className="text-center">
            <p className="text-sm text-gray-600">آخر تحديث</p>
            <p className="text-lg font-medium text-gray-900">
              {new Date(statistics.lastUpdated).toLocaleString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                calendar: 'gregory',
                hour12: true
              })}
            </p>
          </div>
        </Card>
      )}
    </div>
  );
};
